import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

type SkeletonTypes =
  | 'small'
  | 'medium'
  | 'button'
  | 'title'
  | 'selector'
  | 'label'
  | 'resource-title'
  | 'watermark';

@Component({
  selector: 'nr-skeleton',
  templateUrl: './skeleton.html',
  styleUrl: './skeleton.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonComponent {
  readonly type = input<SkeletonTypes>();

  @HostBinding('class') get classAttribute(): Record<string, boolean> {
    const typeValue = this.type();
    return typeValue ? { [typeValue]: true } : {};
  }
}
